import { render, staticRenderFns } from "./automate.vue?vue&type=template&id=6c8a8d90&scoped=true"
import script from "./automate.vue?vue&type=script&lang=js"
export * from "./automate.vue?vue&type=script&lang=js"
import style0 from "./automate.vue?vue&type=style&index=0&id=6c8a8d90&prod&lang=scss"
import style1 from "./automate.vue?vue&type=style&index=1&id=6c8a8d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a8d90",
  null
  
)

export default component.exports